/* eslint-disable */
import {
    Route, Switch, useRouteMatch
} from 'react-router';
// eslint-disable-next-line object-curly-newline
import { CreatePage } from '../../Pages';
import CreateDepartmentPage from '../../Pages/Accounts/MyDepartments/CreateDepartmentPage';
import MyDepartmentsPage from '../../Pages/Accounts/MyDepartments/MyDeaprtmentPage';

const MyDepartmentsRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`}>
                <MyDepartmentsPage createPath={`${path}/add`} />
            </Route>
            <Route exact path={`${path}/add`}>
                <CreatePage createPage={<CreateDepartmentPage />} entity='DEPARTMENTS' />
            </Route>
        </Switch>
    );
};

export default MyDepartmentsRoutes;
